module.exports = __webpack_public_path__ + "static/media/moreIcon.3a53d80d.svg";